/** Stable governance codes a refused change carries at the start of its problem `detail`. */
export const GOVERNANCE_ISSUE_CODES = [
    'NOT_AN_INTEGER',
    'BELOW_MINIMUM',
    'ABOVE_MAXIMUM',
    'NO_CHANGE',
    'REASON_REQUIRED',
    'PENDING_CHANGE_EXISTS',
    'NOT_PENDING',
    'STALE_BASE',
    'SELF_APPROVAL',
    'CHANGE_NOT_FOUND',
    'CONFLICT',
];
/** The stable governance code of a refused change, or undefined for any other failure. */
export function governanceIssueOf(error) {
    const head = error.detail?.split(':', 1)[0]?.trim();
    return GOVERNANCE_ISSUE_CODES.includes(head ?? '') ? head : undefined;
}
const BASE = '/v1/config/security/session-revocation-ttl';
export class SecuritySettingsApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Effective TTL, bounds, pending approval, change trail, and the answering replica's live value. */
    sessionRevocationTtl() {
        return this.client.request({ method: 'GET', path: BASE, auth: true });
    }
    /** Propose a new TTL. A decrease applies at once; an increase waits for a second operator. */
    proposeSessionRevocationTtl(input) {
        return this.client.request({ method: 'POST', path: `${BASE}/changes`, body: input, auth: true });
    }
    /** Four-eyes approval of a pending increase (the approver must not be the requester). */
    approveSessionRevocationTtl(changeId, input) {
        return this.client.request({ method: 'POST', path: `${BASE}/changes/${encodeURIComponent(changeId)}/approve`, body: input, auth: true });
    }
    /** Reject a pending increase (recorded as WITHDRAWN when the requester does it). */
    rejectSessionRevocationTtl(changeId, input) {
        return this.client.request({ method: 'POST', path: `${BASE}/changes/${encodeURIComponent(changeId)}/reject`, body: input, auth: true });
    }
}
//# sourceMappingURL=security-settings.js.map